<template>
  <div>
    <van-calendar
      :poppable="false"
      :show-confirm="false"
      @select="onConfirmDate"
      :style="{ height: '400px' }"
      :date="form.date"
      :min-date="minDate"
      :max-date="maxDate"
      :show-mark="false"
    />
    <!-- <van-divider></van-divider> -->
    <van-field
      readonly
      :clickable="false"
      name="picker"
      :value="form.date"
      label="预约日期"
      placeholder=""
    />

    <!-- <h4>检测地址</h4> -->
    <van-field
      readonly
      clickable
      name="picker"
      :value="form.orgName"
      label="检测机构"
      placeholder="点击选择检测地址"
      @click="orgPicker = true"
    />
    <van-popup v-model="orgPicker" position="bottom" :lazy-render="false">
      <van-picker
        ref="selector"
        show-toolbar
        :columns="orgs"
        @confirm="onConfirmOrg"
        @cancel="orgPicker = false"
      />
    </van-popup>

    <van-field label="详细地址" :value="form.address" readonly />

    <!-- <h4>预约时间</h4> -->
    <van-field
      readonly
      clickable
      name="picker"
      :value="form.resourceText"
      label="预约时间"
      placeholder="点击选择预约时间"
      @click="timePicker = true"
    />
    <van-popup v-model="timePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="medResources"
        @confirm="onConfirmCheckTime"
        @cancel="timePicker = false"
      />
    </van-popup>

    <van-button
      type="warning"
      block
      @click="nextStep"
      class="medium-btn nextStepBtn"
      :disabled="permission"
      >下一步</van-button
    >
  </div>
</template>

<script type="text/ecmascript-6">

import {bookMedResource,getUserBookedResource} from "../../../api/userService"
import { getAllMedOrganization } from "../../../api/MedOrganizationManagementService";
import {
  getResource,
  getBookDateRange,
} from "../../../api/medCheckResourceService";
// import Moment from "moment";
// import {isIOS} from "../../../utils/util"

export default {
  name: "timeSelect",
  data() {
    return {
      //渠道商ID
      channelId:"",
      minDate: new Date(),
      maxDate: new Date(),
      calendarShow: false,
      medResources: [],
      orgs: [
        // { text: '广电计量大厦15层中以生物' , disabled: false ,value:"1"},
      ],
      // show: false,
      timePicker: false,
      orgPicker: false,
      btnDisabled: false,
      teleNum: sessionStorage.getItem("teleNum"),
      //如果是已经预约了
      form: {
        date: "",
        orgUuid: "",
        orgName: "",
        address: "",
        resourceUuid: "",
        resourceText: "",
      },
    };
  },
  computed:{
    permission() {
      if(this.form.date == "" ||
         this.form.orgUuid =="" ||
         this.form.orgName =="" ||
         this.form.resourceUuid == "" ||
         this.form.resourceText == ""
        ){
          return true
        }
        else if(this.btnDisabled === true){
          return true
        }else{
          return false
        }
    },
  },
  // 里面的函数只有调用才会执行
  methods: {
    formatDate(date) {
      // month : 一位数的月份补0
      let iii = date.getMonth() + 1;
      let month = iii/10 <1 ? '0' + iii : iii;
      // day : 一位数的日期补0
      let day = date.getDate() / 10 <1 ? '0' + date.getDate() : date.getDate();
      return `${date.getFullYear()}-${month}-${day}`;
    },
    onConfirmDate(date) {
      this.calendarShow = false;
      this.form.date = this.formatDate(date);
      this.form.resourceUuid = "";
      this.form.resourceText = "";
      this._getMedResource();
    },
    onConfirmOrg(value) {
      this.form.orgName = value.text;
      this.form.orgUuid = value.value;
      this.form.address = value.address;
      // alert(value.address);
      this.orgPicker = false;
      this._getBookDateRange( this.form.orgUuid );
      this._getMedResource();
      //重选检测地点后，挂号预约时间信息记录清空
      this.form.resourceUuid = "";
      this.form.resourceText = "";
    },
    onConfirmCheckTime(value){
      this.timePicker = false;
      if(value.disabled == true) {
        this.$notify({type:"warning",message:"当前时间段已被约完"})
        return
      }
      this.form.resourceText = value.text;
      this.form.resourceUuid = value.value;
    },
    nextStep() {
      this._appointment();
    },
    //Service methods
    _getOrgs() {
      let that = this;
      getAllMedOrganization()
        .then((res) => {
          if (res.success) {
            that.orgs = this.getConvertor(res.data);
            //第一次加载时，设置的检查机构以及 对应的检测挂号资源
            that.getDefaultOrgByRelatedChannelId();
            //获取该组织机构对应的预约日期范围
            that._getBookDateRange(this.form.orgUuid);
            that._getMedResource();

          } else {
            that.$notify({ type: "error", message: res.description });
          }
        })
        .catch((e) => {
          that.$notify({ type: "error", message: e });
        });
    },
    //根据渠道商 设置默认选择的组织机构
    getDefaultOrgByRelatedChannelId(){
      if(this.channelId){
        this.orgs.forEach( org => {
          if(org.relatedChannel == this.channelId){
            //获取 第一个对应渠道商的检测机构，并设为默认选中
            this.form.orgName = org.text;
            this.form.orgUuid = org.value;
            this.form.address = org.address;
            return
          }
        })
      }
      //如果没有渠道商ID,则将第一个组织机构设为默认为选中的检测机构
      else{
        //第一次加载时，设置的检查机构以及 对应的检测挂号资源
        this.form.orgName = this.orgs[0].text;
        this.form.orgUuid = this.orgs[0].value;
        this.form.address = this.orgs[0].address;
      }
    },
    getConvertor(obj) {
      let data = obj;
      let newData = [];
      let item = null;
      let temp = null;
      for (let i = 0; i < data.length; i++) {
        item = data[i];
        temp = {
          text: item.name,
          value: item.orgUuid ,
          relatedChannel:item.relatedChannel,
          address: item.address
        };
        newData.push(temp);
      }
      return newData;
    },

    //可预约的日期范围
    _getBookDateRange(id) {
      let that = this
      getBookDateRange(id)
        .then((res) => {
          if (res.success) {
            // alert(navigator.userAgent.includes('iPhone'))
            //   if( navigator.userAgent.includes('iPhone') ){
                that.minDate = new Date(res.data[0].fromTime.replace(/-/g, "/"));
                that.maxDate = new Date(res.data[0].toTime.replace(/-/g, "/"));
              // }else{
                // that.minDate = new Date(res.data[0].fromTime);
                // that.maxDate = new Date(res.data[0].toTime);
              // }

              //获取到日期取件后，将最近的日期作为默认日期;
              that.form.date = this.formatDate(this.minDate);
              // this._getMedResource();

          } else {
            that.$notify({ type: "error", message: res.description });
          }
        })
        .catch((e) => {
          that.$notify({ type: "error", message: e });
        });
    },

    //根据检测地点，检测日期获取 检测资源（某日的预约挂号资源）
    _getMedResource() {
      // console.log( "formInfo", this.form)
      if (this.form.orgUuid == "") {
        this.$notify({ type: "info",message: "下一步提示：请选择检测地址！"});
        return;
      }
      if (this.form.date == "") {
        this.$notify({ type: "error", message: "请先选择日期！" });
        return;
      }
      console.log("TEST check date format" ,this.form.date)
      let params = this.form.orgUuid + "/" + this.form.date;
      let that =this;
      getResource(params).then((res) => {
        if (res.success) {
          if (res.data) {
            let list = res.data;
            let newList = [];
            if (list.length == 0) {
              this.$notify({
                type: "warning",
                message: "您选择的日期，已无挂号资源，请重选",
              });
              this.medResources = newList;
              return;
            }
            for (let i = 0; i < list.length; i++) {
              let disabled = list[i].resourceLeft == 0 ? true : false;
              let txt = list[i].checkTime.split(" ")[1];
              let item = {
                //日期，只留 时分
                text: txt,
                value: list[i].resourceUuid,
                disabled: disabled,
              };
              newList.push(item);
            }
            that.medResources = newList;
          }
        }
      });
    },
    //预约挂号
    _appointment() {
      //预约按钮点击后，设为禁用，防止再次点击
      this.btnDisabled = true;
      let teleNum = this.teleNum;
      let params = {
        checkTime: this.form.date + " " + this.form.resourceText,
        orgUuid: this.form.orgUuid,
        resourceLeft: 1,
        resourceUuid: this.form.resourceUuid,
        total: 1,
      };
      console.log("params",params);
      if( params.checkTime != "" && params.orgUuid !="" && params.resourceUuid != "") {
        // params.teleNum,
        let channelId = sessionStorage.getItem('channelId');
        let pathParam = "";
        if(channelId) {
          pathParam = teleNum + "/" + channelId
        }
        else {
          pathParam = teleNum
        }

        bookMedResource(pathParam, params).then((res) => {
          if (res.success) {
            // this.$notify({message: res.description, type: "success"});
            this.$toast.success('预约成功');
            this.$router.push({ path: "/appIndex/appointmentResult" });
          } else {
            // this.$notify({ message: res.description, type: "error" });
            this.$notify.error(res.description);
          }
        })
        .catch(e => {
          this.$notify({ message: e, type: "error" });
        })
      }
      else{
        this.$notify({ message: "请选择挂号资源后再预约", type: "success" });
      }
    },

    //获取用户预约的资源
    // 如果已经预约 - 则跳转到 预约结果页面
    _getUserBookedResource() {
      getUserBookedResource(this.teleNum)
        .then((res) => {
          //如果接口调用成功，且有预约资源（res.data存在 ）
          if (res.success) {
            //如果有预约记录,则将状态设置为已经预约
            if (res.data) {
              this.hasBooked = true;
              this.$notify({
                type:'warning',
                message:'您已有预约，即将前往预约结果页面！'
              });

              let that = this;
              setTimeout(() => {
                that.btnDisabled = false;
                that.$router.push({ path: "/appIndex/appointmentResult" });
              },4000)

            }
          } else {
            this.hasBooked = false;
          }
        })
        .catch((e) => {
          this.$notify({
            message: e,
            type: "error",
          });
        });
    },
  },
  created() {
    this.form.date = this.formatDate(new Date());
    this._getUserBookedResource();
    this.channelId = sessionStorage.getItem("channelId");
    //初始化时，获取组织机构后，默认选择第一个机构，根据第一个组织机构ID获取预约日期范围
    this._getOrgs();
  },
};
</script>

<style scoped>
.medium-btn {
  width: 90% !important;
  margin: 10px auto;
}
/* 
.van-tabs__wrap {
        touch-action: manipulation;
    } */

.van-calendar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
  color: white;
}
</style>
